<template>
    <!--公告列表-->
    <div class="layout-right">
        <div class="layout-right-top">
            <RightTop bread="发布管理-公告列表"></RightTop>
        </div>
        <div class="layout-right-body">
            <div class="search-box">
                <el-input v-model="keyword" placeholder="标题关键字" style="width: 300px" @keypress.native="e => {if(e.charCode === 13) loadListData();}" />&nbsp;&nbsp;
                <el-button type="primary" @click="loadListData">&nbsp;&nbsp;搜索&nbsp;&nbsp;</el-button>
                <el-button type="default" @click="addNotice">&nbsp;发布公告&nbsp;</el-button>
            </div>
            <div class="list-box">
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="create_datetime" label="发布时间" width="200" />
                    <el-table-column prop="title" label="标题" />
                    <el-table-column prop="sf_name" label="发布人" width="200" />
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <div class="option-box">
                                <el-button
                                        type="text"
                                        @click="watchNotice(scope.row)"
                                >查看</el-button>
                                <el-button
                                        type="text"
                                        @click="editNotice(scope.row)"
                                >编辑</el-button>
                                <el-button
                                        type="text"
                                        @click="handleDelete(scope.row)"
                                >删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                </el-pagination>
            </div>
        </div>

        <!--发布公告-->
        <NoticeAddBox v-model="addShow" @success="loadListData" :id="noticeId" />
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import NoticeAddBox from "@/model/Notice/NoticeAddBox";
    export default {
        name: "Index",
        components: {NoticeAddBox, RightTop},
        mounted(){
            this.$store.commit("setMenuId", "15-1");
            this.loadListData();
        },
        data(){
            return {
                keyword: "",
                listData:[],
                page: {
                    nowPage: 1,
                    pageSize: 50,
                    pageSizes: [50, 100, 200, 400],
                    count: 0,
                },

                noticeId: "",
                addShow: false
            };
        },
        methods: {
            //每页显示数量变化
            pageSizeChange (val) {
                this.page.pageSize = val;
                this.loadListData();
            },

            //当前页码变化
            pageCurrentChange (val) {
                this.page.nowPage = val;
                this.loadListData();
            },

            //加载数据
            loadListData(){
                let postData = {
                    keyword: this.keyword,
                    page: this.page.nowPage,
                    limit: this.page.pageSize
                };
                this.$root.postData("store_notice/get_list_data", postData, res => {
                    if(res.errcode === 0) {
                        this.listData = res.data;
                        this.page.count = res.count;
                    }else
                        this.$root.error(res.errdesc);
                });
            },

            //发布公告
            addNotice(){
                this.noticeId = "";
                this.addShow = true;
            },

            //编辑公告
            editNotice(data){
                this.noticeId = data.id;
                this.addShow = true;
            },

            //删除公告
            handleDelete(data){
                this.$confirm("您确定要删除公告吗？删除后将无法恢复。", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    let postData = {
                        id: data.id
                    };
                    this.$root.postData("store_notice/delete_data", postData, res => {
                        if(res.errcode === 0) {
                            this.$root.success("公告删除成功");
                            this.loadListData();
                        }else{
                            this.$root.error(res.errdesc);
                        }
                    });
                }).catch(() => {});
            },

            //查看公告
            watchNotice(data){
                this.$root.go("notice/show", {id: data.id}, true);
            }

        }
    }
</script>

<style scoped>
    .search-box{
        background-color: #ffffff;
        padding: 16px;
    }
    .list-box{
        background-color: #ffffff;
        padding: 16px 16px 0;
        margin-top: 16px;
    }
    .page-box{
        border-top: none;
    }
</style>
